import { render, staticRenderFns } from "./new.vue?vue&type=template&id=cd9a75da&scoped=true&"
import script from "./new.vue?vue&type=script&lang=ts&"
export * from "./new.vue?vue&type=script&lang=ts&"
import style0 from "./new.vue?vue&type=style&index=0&id=cd9a75da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd9a75da",
  null
  
)

export default component.exports